import * as yup from 'yup';
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from '@Shared/utils/validationSchema';

export interface IUsersProfileFormMeta {
  profile: FormInputMeta,
  bank: FormInputMeta,
  agence: FormInputMeta,

  schema: any,
}

const UsersProfileFormMeta: IUsersProfileFormMeta = {} as IUsersProfileFormMeta;

UsersProfileFormMeta.profile = {
  label: 'Profile',
  name: 'profile',
  type: 'select',
  options: [
    {
      label: 'Administrateur',
      value: 'admin',
      selected: true,
    },
  ],
  validation: yup.string().required().min(6),
};

UsersProfileFormMeta.agence = {
  label: 'Agence',
  name: 'agence',
  type: 'select',
  options: [
    {
      label: 'Agence1',
      value: 'agence1',
      selected: true,
    },
  ],
  validation: yup.string().required().min(10),
};

UsersProfileFormMeta.bank = {
  label: 'Banque',
  name: 'bank',
  type: 'select',
  options: [
    {
      label: 'Banque 1',
      value: 'bank1',
      selected: true,
    },
  ],
  validation: yup.string().required().min(10),
};

const validationSchema = getValidationSchema(UsersProfileFormMeta);

UsersProfileFormMeta.schema = yup.object().shape({validationSchema});

export default UsersProfileFormMeta;